import React, { FC } from 'react';
import { ImageProps } from '$uikit/Image/Image.interface';
import { isWebpSupported } from '$utils';

export const Image: FC<ImageProps> = ({ src, webp, ...rest }) => {
  const webpSupport = isWebpSupported();
  const image = webpSupport && webp ? webp : src;

  return <img {...rest} src={image} alt={rest.alt} />;
};
